"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _DealsStore = _interopRequireDefault(require("crm_data/deals/DealsStore"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _IsUngatedStore = _interopRequireDefault(require("crm_data/gates/IsUngatedStore"));

var _ScopesContainer = _interopRequireDefault(require("crm_internal/containers/ScopesContainer"));

var _LoadingStatus = require("crm_data/flux/LoadingStatus");

var _BETDealUtils = require("crm_internal/utils/BETDealUtils");

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var BETPartnerCollabDependancy = {
  stores: [_DealsStore.default],
  deref: function deref(_ref) {
    var subjectId = _ref.subjectId,
        objectType = _ref.objectType;

    if (!_ScopesContainer.default.isScoped('bet-partner-collab-card-view')) {
      return false;
    }

    if (objectType !== _ObjectTypes.DEAL) {
      return false;
    }

    var subject = _DealsStore.default.get(subjectId);

    return (0, _LoadingStatus.isResolved)(subject) && _IsUngatedStore.default.get('BET:PartnerCollabNewPipelines') ? (0, _BETDealUtils.isDirectSalesDealPipeline)(subject) || (0, _BETDealUtils.isAdditionalUrlDealPipeline)(subject) || (0, _BETDealUtils.isContractChangePipeline)(subject) || (0, _BETDealUtils.isPromotionDealPipeline)(subject) || (0, _BETDealUtils.isMrrUpgradeDealPipeline)(subject) : (0, _BETDealUtils.isDirectSalesDealPipeline)(subject) || (0, _BETDealUtils.isAdditionalUrlDealPipeline)(subject);
  }
};
BETPartnerCollabDependancy.propTypes = {
  objectType: _ObjectTypesType.default.isRequired,
  subjectId: _propTypes.default.string.isRequired
};
var _default = BETPartnerCollabDependancy;
exports.default = _default;
module.exports = exports.default;